<main class="main">
  <section class="vam_login_section vh-100">
    <div class="container-fluid h-100">
      <div class="row align-items-center h-100">
        <div class="col-md-6 vam_login_car_container">
          <div class="vam_login_car_ani_container">
            <img src="/assets/images/Image-3@2x.png" class="vam_login_car">
          </div>
        </div>
  
        <div class="col-md-6">
          <div class="logo">
            <a href="index.php" class="vam_logo_link">
              <img src="/assets/images/logo2.svg" class="vam_logo">
            </a>
          </div>
          <form class="vam_login_input_form credential mb-4"
            #authFormDirective
            [formGroup]="auth" (submit)="login()">
            <div class="form-group">
              <input type="email" 
                name="email"
                formControlName="email"
                placeholder="{{ 'login.username' | translate }}" 
                class="form-control 
                credential__input"
                autoautocomplete="off"
                [class.is-invalid]="formData.email.invalid && this.submitted">
              
              <div class="form-errors" *ngIf="formData.email.invalid && this.submitted">
                <p class="form-errors__error" *ngIf="formData.email.errors.required">
                  Email is reqired.
                </p>
                <p class="form-errors__error" *ngIf="!formData.email.errors.required && formData.email.errors">
                  Invalid email format
                </p>
              </div>
            </div>

            <div class="form-group">
              <input type="password" 
                name="password"
                formControlName="password"
                placeholder="{{ 'login.password' | translate }}"
                class="form-control 
                credential__input"
                [class.is-invalid]="formData.password.invalid && this.submitted">
              
              <div class="form-errors" *ngIf="formData.password.invalid && this.submitted">
                <p class="form-errors__error" 
                  *ngIf="formData.password.errors.required">
                  Password is reqired.
                </p>
                <p class="form-errors__error" 
                  *ngIf="!formData.password.errors.required && formData.password.errors">
                  Password must be atleast 8 characters.
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="custom-control custom-switch m-0">
                    <input type="radio" 
                      name="lang" 
                      formControlName="lang"
                      value="en" 
                      class="custom-control-input" id="eng"
                      (change)="setLocale('en')">
                    <label class="custom-control-label" for="eng">
                      In English
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <div class="custom-control custom-switch m-0">
                    <input type="radio"
                      name="lang" 
                      formControlName="lang"
                      value="ar" 
                      class="custom-control-input" id="ar"
                      (change)="setLocale('ar')">
                    <label class="custom-control-label" for="ar">
                      {{ 'login.arabic' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="vam_login_btn_container">
              <button type="submit" class="btn btn__primary w-100 mb-2" [disabled]="loaded">
                {{ 'login.login' | translate }}
                <span class="spinner-grow 
                  spinner-grow-sm 
                  text-light ml-2" [hidden]="!loaded">
                </span>
              </button>
            </div>
  
            <div class="vam_login_information mb-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck1">
                <label class="custom-control-label" for="customCheck1">
                  {{ 'login.remember_me' | translate }}
                </label>
              </div>
              <a routerLink="/forgot-password" class="forget">
                {{ 'login.forgot_password' | translate }}
              </a>
            </div>

            <a href="{{dmsURL}}"
              target="_blank" 
              class="btn btn__secondary w-100">
              <span class="icon icon-lg w-100">
                <img src="/assets/images/siarty_logo.svg" alt="">
              </span>
            </a>
          </form>
        </div>
      </div>
    </div>
  </section>
</main>
